import type { ActivityModule } from '../../core/activity';
import { mountMoney } from './ui';
import levelsData from './levels.json';
import './style.css';

export const money: ActivityModule = {
  id: 'money',
  title: 'Dinheiro',
  description: 'Pague usando moedas e notas. Toque nas cédulas pra montar o valor.',
  ageMin: 6,
  ageMax: 10,
  difficulty: 2,
  iconPath: 'assets/gcompris-AGPL/money/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount: mountMoney,
};
